var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "go-block-wrap",
      style:
        _vm.isShowCreateBriefing && !_vm.isShowTab
          ? { height: "calc(100% - 272px)" }
          : {},
    },
    [
      _c(
        "vue-custom-scrollbar",
        {
          ref: "scrollbarRef",
          staticClass:
            "go-modal-inner overflow-y-scroll mCustomScrollbar _mCS_3 mCS-autoHide",
          attrs: { settings: _vm.scrollSettings },
        },
        [
          _c("div", { staticClass: "go-block-body" }, [
            _c(
              "div",
              { staticClass: "go-channel-content" },
              _vm._l(_vm.listChannelRegister, function (item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "go-elements",
                    class: _vm.highLightElement(item),
                  },
                  [
                    _c("dl", [
                      _c("dt", [
                        _c("div", { staticClass: "go-panel-header" }, [
                          _c("ul", [
                            _c("li", [
                              _c("div", { staticClass: "go-channel-img" }, [
                                _c("img", {
                                  staticClass: "mCS_img_loaded",
                                  attrs: {
                                    src: item.channelImageUri,
                                    alt: "logo",
                                  },
                                }),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "go-channel-info" }, [
                                _vm.channelName(item).isShow
                                  ? _c("small", [
                                      _vm._v(
                                        _vm._s(_vm.channelName(item).name)
                                      ),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("strong", [
                                  _vm._v(_vm._s(_vm.getAccountName(item))),
                                ]),
                                _vm._v(" "),
                                _vm.notAliveToken(item)
                                  ? _c("p", { staticClass: "go-channel-msg" }, [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-alert-circle-filled",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "scrap-create.expired-account"
                                            )
                                          )
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("li", [
                              _c("div", { staticClass: "go-channel-btn" }, [
                                _c("div", { staticClass: "dropdown show" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn go-btn-icon",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-expanded": "true",
                                        disabled: !_vm.isOauthAccount(item),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleUpdateAccount(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass:
                                          "go-icon-20 go-icon-user-setting",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "dd",
                        [
                          _vm._l(
                            item.collections,
                            function (collection, accIndex) {
                              return [
                                _c(
                                  "div",
                                  {
                                    key: accIndex,
                                    staticClass: "go-panel-body",
                                  },
                                  [
                                    _c("ul", [
                                      _c("li", [
                                        _c(
                                          "div",
                                          { staticClass: "go-channel-access" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-channel-detail",
                                              },
                                              [
                                                _c(
                                                  "ol",
                                                  _vm._l(
                                                    collection.datasourceList,
                                                    function (
                                                      itemData,
                                                      dataIndex
                                                    ) {
                                                      return _c(
                                                        "li",
                                                        {
                                                          key:
                                                            dataIndex +
                                                            "-" +
                                                            accIndex,
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.titleDatasource(
                                                                  itemData
                                                                )
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(
                                                            "\n                              " +
                                                              _vm._s(
                                                                _vm.valueDatasource(
                                                                  itemData
                                                                )
                                                              ) +
                                                              "\n                            "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "go-channel-detail-btns",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "custom-control custom-switch",
                                                  },
                                                  [
                                                    _c("input", {
                                                      staticClass:
                                                        "custom-control-input",
                                                      attrs: {
                                                        type: "checkbox",
                                                        disabled:
                                                          _vm.notAliveToken(
                                                            item
                                                          ),
                                                        id:
                                                          item.channelType +
                                                          item.accountId +
                                                          (collection.bpId ||
                                                            "-") +
                                                          accIndex,
                                                      },
                                                      domProps: {
                                                        checked:
                                                          collection.isScrap,
                                                      },
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          return _vm.onChangeScrap(
                                                            item,
                                                            accIndex,
                                                            $event.target
                                                              .checked
                                                          )
                                                        },
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("label", {
                                                      staticClass:
                                                        "custom-control-label",
                                                      attrs: {
                                                        for:
                                                          item.channelType +
                                                          item.accountId +
                                                          (collection.bpId ||
                                                            "-") +
                                                          accIndex,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _vm.handleEditDatasource(
                                                  collection
                                                )
                                                  ? _c(
                                                      "button",
                                                      {
                                                        staticClass:
                                                          "btn go-btn-icon",
                                                        attrs: {
                                                          type: "button",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSetting(
                                                              item,
                                                              collection
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "go-icon-20 go-icon-edit",
                                                        }),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        collection.bpId
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "go-channel-link",
                                              },
                                              [
                                                _c(
                                                  "button",
                                                  {
                                                    staticClass:
                                                      "btn go-btn-default",
                                                    attrs: { type: "button" },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleShowFull(
                                                          collection.bpId
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "go-icon-16 go-icon-browser-share",
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "em",
                                                      {
                                                        staticClass: "go-text",
                                                        staticStyle: {
                                                          "word-break":
                                                            "break-all",
                                                        },
                                                        style: _vm
                                                          .isShowFullMap[
                                                          collection.bpId
                                                        ]
                                                          ? "-webkit-line-clamp: none"
                                                          : "-webkit-line-clamp: 1",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                            " +
                                                            _vm._s(
                                                              collection.bpName
                                                            ) +
                                                            "\n                          "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]),
                                  ]
                                ),
                              ]
                            }
                          ),
                        ],
                        2
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "go-list-content form bottom" }, [
        _c("div", { staticClass: "go-form-group" }, [
          _c("div", { staticClass: "go-block-between" }, [
            _c("label", { staticClass: "go-form-label" }, [
              _vm._v(_vm._s(_vm.$t("privacy-setting"))),
              _c("sup", [_vm._v("*")]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-info-inline" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio go-form-check-inline",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.briefingPrivacy,
                        expression: "formData.briefingPrivacy",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      value: "PUBLIC",
                      id: "go-option-public",
                      name: "briefingPublicPublic",
                      checked: "",
                    },
                    domProps: {
                      checked: _vm._q(_vm.formData.briefingPrivacy, "PUBLIC"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.formData,
                          "briefingPrivacy",
                          "PUBLIC"
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "go-option-public" },
                    },
                    [_vm._v(_vm._s(_vm.$t("scrap-agent.public")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-radio go-form-check-inline",
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.formData.briefingPrivacy,
                        expression: "formData.briefingPrivacy",
                      },
                    ],
                    staticClass: "custom-control-input",
                    attrs: {
                      type: "radio",
                      id: "go-option-private",
                      name: "briefingPublicPrivate",
                      value: "PRIVATE",
                    },
                    domProps: {
                      checked: _vm._q(_vm.formData.briefingPrivacy, "PRIVATE"),
                    },
                    on: {
                      change: function ($event) {
                        return _vm.$set(
                          _vm.formData,
                          "briefingPrivacy",
                          "PRIVATE"
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "go-option-private" },
                    },
                    [_vm._v(_vm._s(_vm.$t("scrap-agent.private")))]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }